konnyScript(function($){
  //new copy txt
  $('.copyTxt').on('click', function (e) {
    e.preventDefault();

    const text = $(this).attr('data-clipboard-text')?.trim();
    if (!text) {
      return;
    }

    const $temp = $('<textarea>');
    $('body').append($temp);
    $temp.val(text).select();

    try {
      const success = document.execCommand('copy');
      $temp.remove();

      if (success) {
        alert('複製成功！');
      } else {
        alert('複製失敗，請親自複製連結使用。');
      }
    } catch (err) {
      $temp.remove();
      alert('複製失敗，請親自複製連結使用。');
    }
  });
  
});